export const COMBINATION_OPTIONS = () => ({ MAX_OBJECTS: 10 });



// WEBPACK FOOTER //
// ./src/app/merchants/combinations/combinations.constants.js